/*=========================================================================================
  File Name: moduleTodoMutations.js
  Description: Todo Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_LIST(state, payload) {
    state.services = payload.data;
    state.totalItems = payload.totalItems;

  },
  ADD_NEW(state, payload) {
    state.services.unshift(payload);
  },
  REMOVE_RECORD(state, payload) {
    state.services.splice(payload, 1);
  },
  UPDATE(state, payload) {
    state.services[payload.index] = payload.service;
  }

};
